
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Calendar, MessageCircle, Users, User, Bell, Image } from 'lucide-react';
import ROUTES from '@/routes-map';
import { useAuth } from '@/contexts/AuthContext';

const DoctorBottomNav = () => {
  const location = useLocation();
  const { user } = useAuth();
  
  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };
  
  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-background border-t border-border py-2 z-40 md:hidden">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center">
          <Link 
            to={ROUTES.DOCTOR.DASHBOARD} 
            className={`flex flex-col items-center p-2 ${isActive(ROUTES.DOCTOR.DASHBOARD) || location.pathname === '/' ? 'text-primary' : 'text-muted-foreground'}`}
          >
            <Home className="h-5 w-5" />
            <span className="text-xs mt-1">Home</span>
          </Link>
          
          <Link 
            to={ROUTES.DOCTOR.PATIENTS} 
            className={`flex flex-col items-center p-2 ${isActive(ROUTES.DOCTOR.PATIENTS) ? 'text-primary' : 'text-muted-foreground'}`}
          >
            <Users className="h-5 w-5" />
            <span className="text-xs mt-1">Patients</span>
          </Link>
          
          <Link 
            to={ROUTES.DOCTOR.AVAILABILITY} 
            className={`flex flex-col items-center p-2 ${isActive(ROUTES.DOCTOR.AVAILABILITY) ? 'text-primary' : 'text-muted-foreground'}`}
          >
            <Calendar className="h-5 w-5" />
            <span className="text-xs mt-1">Appointments</span>
          </Link>
          
          <Link 
            to={ROUTES.DOCTOR.MESSAGES.ROOT} 
            className={`flex flex-col items-center p-2 ${isActive(ROUTES.DOCTOR.MESSAGES.ROOT) || isActive('/chat') ? 'text-primary' : 'text-muted-foreground'}`}
          >
            <MessageCircle className="h-5 w-5" />
            <span className="text-xs mt-1">Chat</span>
          </Link>
          
          <Link 
            to={ROUTES.DOCTOR.SETTINGS} 
            className={`flex flex-col items-center p-2 ${isActive(ROUTES.DOCTOR.SETTINGS) || isActive(ROUTES.DOCTOR.PROFILE) ? 'text-primary' : 'text-muted-foreground'}`}
          >
            <User className="h-5 w-5" />
            <span className="text-xs mt-1">Settings</span>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default DoctorBottomNav;
